var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.61536 13.3846H6.1154C6.34423 13.3846 6.53605 13.4621 6.69086 13.617C6.84567 13.7718 6.92307 13.9637 6.92307 14.1927C6.92307 14.4216 6.84567 14.6134 6.69086 14.768C6.53605 14.9227 6.34423 15 6.1154 15H1.97338C1.6976 15 1.46643 14.9067 1.27987 14.7201C1.09329 14.5336 1 14.3024 1 14.0266V9.88459C1 9.65577 1.07744 9.46395 1.23232 9.30914C1.3872 9.15433 1.57911 9.07693 1.80805 9.07693C2.037 9.07693 2.22879 9.15433 2.38342 9.30914C2.53805 9.46395 2.61536 9.65577 2.61536 9.88459V13.3846ZM13.3846 2.61536H9.88459C9.65577 2.61536 9.46395 2.53792 9.30914 2.38304C9.15433 2.22818 9.07693 2.03627 9.07693 1.80732C9.07693 1.57838 9.15433 1.3866 9.30914 1.23197C9.46395 1.07732 9.65577 1 9.88459 1H14.0266C14.3024 1 14.5336 1.09329 14.7201 1.27987C14.9067 1.46643 15 1.6976 15 1.97338V6.1154C15 6.34423 14.9226 6.53605 14.7677 6.69086C14.6128 6.84567 14.4209 6.92307 14.192 6.92307C13.963 6.92307 13.7712 6.84567 13.6166 6.69086C13.4619 6.53605 13.3846 6.34423 13.3846 6.1154V2.61536Z",
    fill: "#0080AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoExpand);
export default __webpack_public_path__ + "static/media/ico_expand.12d1132e3aab26ae0e477ea5f95ff2fa.svg";
export { ForwardRef as ReactComponent };